import { createPortal } from "react-dom";
import { useScrollLock } from "../../../hooks/useScrollLock";
import styles from "./dialogPopup.module.scss";

interface iProps {
  className?: string;
  isOpen: boolean;
  children: JSX.Element;
  nested?: boolean;
  // When true, suppress the 1s `modalShow` opacity fade-in on open. Use when one
  // DialogPopup hands off to ANOTHER (e.g. the in-chat hotel pre-fetch skeleton
  // dialog → the global SelectRoomModal). Each DialogPopup portals its OWN
  // backdrop, so the taking-over dialog is a fresh DOM node that re-runs the fade
  // from opacity 0 — the dark backdrop visibly "resets" to transparent mid-shift.
  // Rendering it at full opacity immediately keeps the backdrop continuous.
  disableEnterAnimation?: boolean;
}
function DialogPopup(props: iProps): JSX.Element | null {
  const { className, isOpen = false, children, nested = false, disableEnterAnimation = false } = props;
  useScrollLock(isOpen);

  const layerClass = nested ? styles.nested : "";

  const node = !isOpen ? (
    <div className={`${className} ${styles.modal} ${layerClass} ${isOpen ? styles.isOpen : styles.hide} ${
        disableEnterAnimation ? styles.noEnterAnim : ""
      }`}>
      <div
        className={styles.backdrop}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
      {children}
    </div>
  ) : (
    <div
      className={`${className} ${styles.modal} ${layerClass} ${isOpen ? styles.isOpen : styles.hide} ${
        disableEnterAnimation ? styles.noEnterAnim : ""
      }`}
      onTouchMove={(e) => {
        e.stopPropagation();
      }}
      onDrag={(e) => {
        e.stopPropagation();
      }}
      onTouchStart={(e) => {
        e.stopPropagation();
      }}
      onScroll={(e) => {
        e.stopPropagation();
      }}
    >
      {children}
    </div>
  );

  return createPortal(node, document.body);
}

DialogPopup.defaultProps = {
  className: "",
};

export default DialogPopup;
